export const OnboardingAutomationIds = {
  dialog: 'onboarding-dialog',
  welcomeGetStarted: 'onboarding-welcome-get-started',
  applicationNameInput: 'onboarding-application-name-input',
  applicationUrlInput: 'onboarding-application-url-input',
  applicationEnvironmentSelect: 'onboarding-application-environment-select',
  applicationInternalSwitch: 'onboarding-application-internal-switch',
  applicationSubmit: 'onboarding-application-submit',
  applicationSuccessContinue: 'onboarding-application-success-continue',
  applicationSuccessClose: 'onboarding-application-success-close',
  sourceCodeContinueWithout: 'onboarding-source-code-continue-without',
  sourceCodeProtoSchemaFileInput:
    'onboarding-source-code-proto-schema-file-input',
  sourceCodeProtoSchemaCompileResult:
    'onboarding-source-code-proto-schema-compile-result',
  repositoriesChoose: 'onboarding-repositories-choose',
  repositoriesChooseLater: 'onboarding-repositories-choose-later',
  sourceCodeSuccessContinue: 'onboarding-source-code-success-continue',
  advancedSettingsTestingScopeSection:
    'onboarding-advanced-settings-testing-scope-section',
  advancedSettingsCredentialsSection:
    'onboarding-advanced-settings-credentials-section',
  advancedSettingsAutomationsSection:
    'onboarding-advanced-settings-automations-section',
  advancedSettingsBusinessContextSection:
    'onboarding-advanced-settings-business-context-section',
  advancedSettingsGuardrailsSection:
    'onboarding-advanced-settings-guardrails-section',
  advancedSettingsPentestReportAction:
    'onboarding-advanced-settings-pentest-report-action',
  advancedSettingsFooter: 'onboarding-advanced-settings-footer',
  scheduledReportsAutomationsDialog:
    'onboarding-scheduled-reports-automations-dialog',
  scheduledReportsEnabledSwitch: 'onboarding-scheduled-reports-enabled-switch',
  scheduledReportsFrequencyEdit: 'onboarding-scheduled-reports-frequency-edit',
  scheduledReportsFrequencyDialog:
    'onboarding-scheduled-reports-frequency-dialog',
  scheduledReportsFrequencyAdd: 'onboarding-scheduled-reports-frequency-add',
  scheduledReportsFrequencyMonthly:
    'onboarding-scheduled-reports-frequency-monthly',
  scheduledReportsMonthlyDaySelect:
    'onboarding-scheduled-reports-monthly-day-select',
  scheduledReportsHourEdit: 'onboarding-scheduled-reports-hour-edit',
  scheduledReportsHourDialog: 'onboarding-scheduled-reports-hour-dialog',
  scheduledReportsHourSelect: 'onboarding-scheduled-reports-hour-select',
  scheduledReportsHourSave: 'onboarding-scheduled-reports-hour-save',
  scheduledReportsTimezoneEdit: 'onboarding-scheduled-reports-timezone-edit',
  scheduledReportsTimezoneDialog:
    'onboarding-scheduled-reports-timezone-dialog',
  scheduledReportsTimezoneSelect:
    'onboarding-scheduled-reports-timezone-select',
  scheduledReportsTimezoneSave: 'onboarding-scheduled-reports-timezone-save',
  scheduledReportsAutomationsDone:
    'onboarding-scheduled-reports-automations-done',
  pentestReportDialog: 'onboarding-pentest-report-dialog',
  pentestReportDateInput: 'onboarding-pentest-report-date-input',
  pentestReportSave: 'onboarding-pentest-report-save',
  integrationsSectionNotifications:
    'onboarding-integrations-section-notifications',
  integrationsSectionTicketing: 'onboarding-integrations-section-ticketing',
  integrationsSectionKnowledgeBase:
    'onboarding-integrations-section-knowledge-base',
  integrationsFooter: 'onboarding-integrations-footer',
  integrationsCompleteDashboard: 'onboarding-integrations-complete-dashboard',
  close: 'onboarding-close',
} as const;

export const onboardingEnvironmentOptionId = (environment: string) =>
  `onboarding-application-environment-option-${environment.toLowerCase().replace(/\s+/g, '-')}`;
